const state = {
  taxSettings: {
    percent: 0,
    enabled: false,
  },
  isTaxSettingsLoading: false,
};

export default state;
